module.exports = __webpack_public_path__ + "img/classify2.80aa9ec.png";